const PostClosingTestIdsScope = {
  INVESTOR_EDIT_FORM: 'investor-edit-form',
};

export const PostClosingTestIds = {
  // PostClosing.js
  ADD_DOCUMENT_BUTTON: 'post-closing.add-document-button',
  EDIT_MERS_BUTTON: 'post-closing.edit-mers-button',
  EDIT_FLIPPED_UNSALABLE_BUTTON: 'post-closing.edit-flipped-unsalable-button',

  // PostClosing.config - investorEditConfigFields
  INVESTOR_EDIT_FORM_DUE_DATE_INPUT: `${PostClosingTestIdsScope.INVESTOR_EDIT_FORM}.due-date-input`,
};
